
















import { Vue, Component, Prop } from "vue-property-decorator";
import { CombinedRule, Rule } from "../core/messages";

@Component({
  components: {
    RuleWrapper: () => import("./RuleWrapper.vue")
  }
})
export default class CombinedRuleComp extends Vue {
  // Props
  @Prop({ required: true, type: Object })
  value!: CombinedRule;

  // Data
  // Computed
  // Methods
  addRule() {
    this.$emit("input", {
      op: this.value.op,
      rules: [
        ...this.value.rules,
        {
          op: "==",
          field: "roonVersion",
          value: ""
        }
      ]
    });
  }

  updateRule(rule: Rule, index: number) {
    this.$emit("input", {
      op: this.value.op,
      rules: this.value.rules.map((r, i) => {
        if (i === index) {
          return rule;
        }
        return r;
      })
    });
  }

  removeRule(index: number) {
    this.$emit("input", {
      op: this.value.op,
      rules: this.value.rules.filter((r, i) => i !== index)
    });
  }

  // Life-cycle hooks
}
